import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { Container } from '@comparethemarketau/manor-grid';
import { connect } from 'react-redux';
import { resultsConfigSelector } from 'ctm-selectors';

import { UpdateResultsSection } from './common/update_results_section';
import { AlexanderHalfPicture } from './common/alexander_half_picture';
import { FiltersGroup } from './common/filters_group';

import { ContainerWrapper } from '../container_wrapper';

const useStyles = createUseStyles((theme) => ({
    container: {
        backgroundColor: theme.colors.white,
        borderBottom: `${theme.spacing.px} solid ${theme.colors.primary200}`
    },
    updateResultsSection: {
        marginLeft: theme.spacing[32]
    }
}));

const _PolicyFiltersSm = (props) => {
    const { isShowFiltersUpdateButton, padding } = props;
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <ContainerWrapper padding={padding} className={classNames('test-policyFilters-sm')}>
            <div className={classes.container}>
                <Container padding={['0', '32', '0', '32']}>
                    <Container padding={['16', '0', '8', '40']}>
                        <FiltersGroup />
                    </Container>
                    {
                        !isShowFiltersUpdateButton && <AlexanderHalfPicture />
                    }
                </Container>
                <UpdateResultsSection className={classes.updateResultsSection} />
            </div>
        </ContainerWrapper>
    );
};

_PolicyFiltersSm.propTypes = {
    isShowFiltersUpdateButton: PropTypes.bool,
    padding: PropTypes.array
};

const mapStateToProps = (state) => {
    // vertical.quote.results.config.filters.showFiltersUpdateButton
    const resultsStagedStateKey = 'filters.showFiltersUpdateButton';
    const isShowFiltersUpdateButton = resultsConfigSelector(state).getIn(resultsStagedStateKey.split('.'));
    return {
        isShowFiltersUpdateButton
    };
};

const PolicyFiltersSm = connect(mapStateToProps)(_PolicyFiltersSm);
export { PolicyFiltersSm };
